import React from 'react';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import Utils from '../../../../../common/utils/Utils';
import { connect } from 'react-redux';

function ListAdapter(props) {
  var data = props.settings.Data;
  var rowConfig = props.settings.Configuration.rowConfig;
  return (
    <div>
      <Table style={{ tableLayout: 'auto' }} data-qa="qa-instrument-data">
        <TableBody>
          {data.length ? (
            data.map((el, elIndex) =>
              rowConfig.map((row, rowIndex) =>
                determineListContent(el, elIndex, row, props.globalSettings)
              )
            )
          ) : (
            <TableRow>
              <TableCell>
                <p className="no-data">No data to show</p>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}

const determineListContent = (el, elIndex, rowConfig, globalSettings) => {
  var value = el[rowConfig['key']];
  switch (rowConfig.type) {
    case 'ticks':
      return (
        <TableRow key={elIndex}>
          <TableCell style={{ fontWeight: 'bold' }}>{rowConfig.name}</TableCell>
          <TableCell>{value ? Utils.determineHourMinutesSecondsFromTicks(+value) : ''}</TableCell>
        </TableRow>
      );
    case 'percentage':
      return (
        <TableRow key={elIndex}>
          <TableCell style={{ fontWeight: 'bold' }}>{rowConfig.name}</TableCell>
          <TableCell>{`${Utils.FormatNumber(+value, globalSettings)}%`}</TableCell>
        </TableRow>
      );
    default:
      return (
        <TableRow key={elIndex}>
          <TableCell style={{ fontWeight: 'bold' }}>{rowConfig.name}</TableCell>
          <TableCell>{value}</TableCell>
        </TableRow>
      );
  }
};

const mapStateToProps = (state) => ({
  globalSettings: state.user ? state.user.Settings : undefined,
});

export default connect(mapStateToProps)(ListAdapter);
